import * as types from './actionTypes';

const initialState = {
  /** Key: `${packageId}_${type}` (e.g. "5_salesAgent"), value: API response (sources or sales_agents list) */
  byPackageAndType: {},
  loading: false,
};

function getCacheKey(packageId, type) {
  return `${packageId}_${type}`;
}

export const packageSourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PACKAGE_SOURCE_LIST: {
      const { packageId, type, data } = action.payload;
      const key = getCacheKey(packageId, type);
      return {
        ...state,
        byPackageAndType: {
          ...state.byPackageAndType,
          [key]: data,
        },
        loading: false,
      };
    }
    case types.GET_PACKAGE_SOURCE_LIST:
      return {
        ...state,
        loading: true,
      };
    case types.CLEAR_PACKAGE_SOURCE_LIST:
      return {
        ...state,
        byPackageAndType: {},
      };
    default:
      return state;
  }
};
